module.exports = __webpack_public_path__ + "img/alert-ico.b7d53cdb.svg";